// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_6j","postedByDate":"e_7j","container":"e_8j","description":"e_9j","title":"e_-j"};